import { ChangeDetectorRef, Component, OnInit, ViewChild } from '@angular/core';
import { FarmService } from 'src/app/content/farm/farm.service';
import { Farm } from 'src/app/shared/dtos/Farm';
import { UtilsService } from 'src/app/util/services/utils.service';
import { Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { NotificationService } from 'src/app/util/services/notification.service';
import { MatPaginator } from '@angular/material/paginator';
import { MatTableDataSource } from '@angular/material/table';
import { Observable } from 'rxjs';

@Component({
  selector: 'app-my-farms',
  templateUrl: './my-farms.component.html',
  styleUrls: ['./my-farms.component.css']
})
export class MyFarmsComponent implements OnInit {

  popUpDeleteFarmResponse: any;
  @ViewChild(MatPaginator) paginator: MatPaginator;
  farmCards: Observable<any>;
  dataSource: MatTableDataSource<Farm>;

  constructor(
    private farmService: FarmService,
    private utilService: UtilsService,
    private router: Router,
    private notificationService: NotificationService,
    private translate: TranslateService,
    private changeDetectorRef: ChangeDetectorRef) { }

  myFarms: Farm [];

  ngOnInit(): void {
    this.getFarmsCurrentUser();
    this.changeDetectorRef.detectChanges();
  }

  getFarmsCurrentUser(){
    this.farmService.getFarmsCurrentUser().subscribe(
      (farms) => {
        this.dataSource = new MatTableDataSource<Farm>(farms);
        this.myFarms = farms;
        this.dataSource.paginator = this.paginator;
        this.farmCards = this.dataSource.connect();
      },
      () => {
        this.notificationService.showError(this.translate.instant('ERROR_GET_MY_FARMS'), 5);
      }
    );
  }

  deleteFarm(farm: Farm){
    this.utilService.deleteDialog(this.translate.instant('FARM.DELETE_FARM_MODAL_CONFIRMATION')).
    subscribe( res => {this.popUpDeleteFarmResponse = res;},
               err => console.log(err),
               ()  => this.getDeleteResponse(this.popUpDeleteFarmResponse, farm));

  }

  getDeleteResponse(response : string, farm: Farm){
    if(response == "yes"){
      this.farmService.deleteFarm(farm)
        .subscribe(
          () => {
            this.getFarmsCurrentUser();
            this.notificationService.showSuccess(this.translate.instant('SUCCESS_DELETE_FARM'), 5);
          },
          () => this.notificationService.showError(this.translate.instant('ERROR_DELETE_FARM'), 5)
        );
    }
 }

 editFarm(id: number){
  this.router.navigateByUrl('edit-farm/' + id )
 }

 ngOnDestroy() {
  if (this.dataSource) { 
    this.dataSource.disconnect(); 
  }
}

}
